/**
 * The three API clients. Guest and staff are wired to separate token stores, so a 401 on one clears only
 * that session, and neither client can ever send the other's token. The public client sends no token.
 */
import { guestSessionStore } from '@/auth/guest-session';
import { staffSessionStore } from '@/auth/staff-session';
import { createApiClient } from './client';

/** No Authorization header: staff login, QR resolution and joining a session. */
export const publicApi = createApiClient();

export const guestApi = createApiClient({
  getToken: () => guestSessionStore.get()?.token ?? null,
  onUnauthorized: () => guestSessionStore.clear('unauthorized'),
});

export const staffApi = createApiClient({
  getToken: () => staffSessionStore.get()?.token ?? null,
  onUnauthorized: () => staffSessionStore.clear('unauthorized'),
});
